import "regenerator-runtime/runtime"
import React, { Suspense } from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import * as Sentry from "@sentry/react"
import settings from "settings"
global.Sentry = Sentry
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"

import { createStore, applyMiddleware } from "redux"
import thunk from "redux-thunk"
import promise from "redux-promise"
import allReducers from "./reducers"
import { composeWithDevTools } from "redux-devtools-extension"
import { initialState } from "./initialState"

import Login from "./containers/general/Login"
import ForgotPassword from "./containers/ForgotPassword"
import ResetPassword from "./containers/ResetPassword"
const ModelMap = React.lazy(() => import("./containers/ModelMap"))
import Logout from "./components/Logout"
import Authenticated from "./containers/Authenticated"
import Navigator from "./containers/consumer/navigator"
import ExecutiveWeekly from "islands/executiveWeekly"
import WeeklyReport from "islands/weekly"
import { ToastContainer, toast } from "react-toastify"
import currentUser from "helpers/currentUser"
import ReactLoading from "react-loading"

const sentryReduxEnhancer = Sentry.createReduxEnhancer({})
let middlewares = [thunk, promise]
const store = createStore(
	allReducers,
	initialState,
	//composeWithDevTools(applyMiddleware(thunk, promise, logger))
	composeWithDevTools(applyMiddleware(...middlewares), sentryReduxEnhancer)
)
if (window.location.hostname !== "localhost") {
	let user = currentUser()
	let state = store.getState()
	Sentry.init({
		dsn: settings.sentry,
	})

	Sentry.setContext("pipsyData", {
		userId: user ? user.id : null,
		activeProperties: state.activeProperties,
	})
	/* Sentry.configureScope((scope) => {
		if (user) {
			scope.setExtra("userId", currentUser().id)
		}
		if (state.activeProperties) {
			//scope.setExtras("activeProperties", state.activeProperties)
		}
		// scope.clear();
	}) */
}
ReactDOM.render(
	<>
		<Provider store={store}>
			<Router>
				<Suspense
					fallback={
						<div className="w-full h-full fixed flex justify-center items-center">
							<ReactLoading color={"#0A61DF"} type={"spin"} />
						</div>
					}>
					<Switch>
						<Route
							path="/island/executiveWeekly/:key"
							component={ExecutiveWeekly}
							name="Executive Weekly"
						/>
						<Route path="/island/weekly/:key" component={WeeklyReport} name="Weekly Report" />
						<Route path="/navigator" component={Navigator} name="Navigator" />
						<Route path="/login" component={Login} name="Login" />
						<Route path="/forgot-password" component={ForgotPassword} name="Forgot Password" />
						<Route path="/reset-password" component={ResetPassword} name="Reset Password" />
						<Route path="/logout" component={Logout} name="Logout" />
						<Route path="/modelMap/:property_id/:builder_id" component={ModelMap} name="Model Map" />
						<Route path="/" component={Authenticated} name="Authenticated" />
					</Switch>
				</Suspense>
			</Router>
		</Provider>
		<ToastContainer autoClose={4000} position={toast.POSITION.BOTTOM_LEFT} />
	</>,
	document.getElementById("root")
)
